// Imports React
import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';

// Imports third-party
import Layout from '../components/layout';
import Products from './products';
import ProductDetail from './productDetail';
import AboutPage from './about';
import RouletteWheel from './roulette';
import RouletteSettings from './roulette/settings';
import SimpleRouletteWheel from './roulette/simple';
import PrizesRouletteWheel from './roulette/prizes';
// import About from "./about";

// Lazy load pages
const Home = lazy(() => import('./home'));

/**
 * Route configuration array
 */
const routes = [
  {
    path: '/',
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
  {
    path: '/products',
    element: (
      <Layout>
        <Products />
      </Layout>
    ),
  },
  {
    path: '/products/:id',
    element: (
      <Layout>
        <ProductDetail />
      </Layout>
    ),
  },
  {
    path: '/about',
    element: (
      <Layout>
        <AboutPage />
      </Layout>
    ),
  },
  {
    path: '/roulette',
    element: (
      <Layout>
        <RouletteWheel />
      </Layout>
    ),
  },
  {
    path: '/roulette/settings',
    element: (
      <Layout>
        <RouletteSettings />
      </Layout>
    ),
  },
  {
    path: '/roulette/simple',
    element: (
      <Layout>
        <SimpleRouletteWheel />
      </Layout>
    ),
  },
  {
    path: '/roulette/prizes',
    element: (
      <Layout>
        <PrizesRouletteWheel />
      </Layout>
    ),
  },
];

/**
 * Route settings to be used by RouterProvider in main.tsx
 */
export const router = createBrowserRouter(routes);
